"use client";
import React from "react";
import { useModalCustomerContext } from "@/context/CustomerContext";
import Image from "next/image";
const CustomerBtn = ({ className }: { className?: string }) => {
	const { isCustomerModalOpen, openModalCustomer } = useModalCustomerContext();

	return (
		<>
			<button
				type="button"
				onClick={openModalCustomer}
				className={`group relative cursor-pointer rounded-full bg-white p-1 text-black shadow-mainShadow transition-all duration-300 hover:-translate-y-1.5 ${
					isCustomerModalOpen ? "opacity-0" : "opacity-100"
				} ${className ?? ""}`}
			>
				<i className="ri-chat-smile-2-line px-2 text-[30px]"></i>
			</button>
		</>
	);
};

export default CustomerBtn;
